import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"padding":"10px 0px"} }
const _hoisted_2 = { style: {"height":"56px","width":"56px"} }
const _hoisted_3 = ["src"]
const _hoisted_4 = { style: {"font-size":"13px","color":"#5f6368","font-weight":"600","margin":"0px"} }
const _hoisted_5 = { style: {"font-size":"12px","color":"#5f6368","font-weight":"600","margin":"0px","margin-top":"2px"} }
const _hoisted_6 = { style: {"display":"flex","margin-top":"2px","align-items":"center"} }
const _hoisted_7 = { style: {"color":"#5f6368","font-size":"11px","margin":"0px","margin-right":"2px"} }



export default /*@__PURE__*/_defineComponent({
  __name: 'SimilarGame',
  props: {
    gameName: {
        type: String,
        default: '',
    },
    subHeading: {
        type: String,
        default: '',
    },
    rate: {
        type: Number,
        default: () => 0,
    },
    img: {
        type: String,
        default: 'similarOne',
    }
},
  setup(__props) {

const props = __props

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_van_col, { span: 10 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("img", {
                style: {"height":"100%","width":"100%","object-fit":"cover","border-radius":"10px"},
                src: props.img
              }, null, 8, _hoisted_3)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_van_col, { span: 12 }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_4, _toDisplayString(__props.gameName), 1),
            _createElementVNode("p", _hoisted_5, _toDisplayString(__props.subHeading), 1),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("p", _hoisted_7, _toDisplayString(__props.rate), 1),
              _createVNode(_component_van_icon, {
                name: "star",
                color: "#5f6368",
                size: "10"
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})